import React, {
  useState,
  useMemo,
  useEffect,
  useCallback,
  useImperativeHandle,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  toggleSelectedSong,
  addSongToPlaylist,
  sortSongs,
  updateMusicPositions,
} from "../../../../../../store/ContentPlaylists/actions";

import {
  openModal as openModalInner,
  closeModal as closeModalInner,
} from "../../../../../../store/Modal/actions";
import List from "../../../../../../components/DraggableList";
import SvgArrowUpDown from "../../../../../../components/SVG/ArrowUpDown";

import Button from "../../../../../../components/Button";
import Ok from "../../../../../../components/SVG/Ok";
import Trash from "../../../../../../components/SVG/Trash";

import Save from "../../../../../../components/SVG/Save";

import { updateCurrentMark } from "../../../../../../store/Marks/actions";
import { MEDIA_BREAKPOINT_LG } from "../../../../../../utilities/breakpoints";
import ElementsGroup from "../../../../../../components/ElementsGroup";
import { debounce } from "../../../../../../utilities/debounce";
import Song from "../Songs";
import { cl } from "../../../../../../utilities/cl";

const UserPlaylist = React.forwardRef(
  ({ toggleSelected, hPlay: hPlayInner, hStop, hPause, hRewind, selectAllS }, ref) => {
    const dispatch = useDispatch();

    const hPlay = (data) => hPlayInner({ ...data, from: 'current' })

    const {
      currentPlaylist,
      searched_value_ref,
      selected_song,
      selectedPlaylists,
      selected,
    } = useSelector((state) => ({
      searched_value_ref: state.search.songs.value,
      selected_song: state.playlists.selected_song,
      selected: state.playlists.selected,
      selectedPlaylists: state.playlists.selected,
      currentPlaylist: state.playlists.allPlaylists.find(
        (cur) => cur.id === state.playlists.selected[0]
      ),
    }));


    const [searched_value, setSearchedValue] = useState("");
    const openModal = (data) => dispatch(openModalInner(data));
    const closeModal = (data) => dispatch(closeModalInner(data));
    const [sort_direction, setSortDirection] = useState("");
    const [sortField, setSort] = useState()
    const [loading, setLoading] = useState(false);
    const [playlist_items_ref, setPlaylistItems] = useState([]);

    useEffect(() => {
      setLoading(true);
      setTimeout(() => setLoading(false), 50)
    }, [
      sortField
    ])

    useImperativeHandle(ref, () => ({
      currentPlaylistId: currentPlaylist?.id,
      currentPlaylist,
      playlist_items_ref,
      setPlaylistItems,
    }));

    const deleteSongs = () => {
      let clear = playlist_items
        .map((song) => {
          return song.id;
        })
        .filter((id) => selected_song.indexOf(id) === -1);
      let playlist_items_update = Array.from(playlist_items).filter(
        (song) => selected_song.indexOf(song.id) === -1
      );
      setPlaylistItems([...playlist_items_update]);
      dispatch(
        addSongToPlaylist({
          id_playlist: selectedPlaylists[0],
          selected_song: clear,
          songs: playlist_items_update,
        })
      );
    };

    const updateSearch = React.useCallback(
      debounce((value) => {
        setSearchedValue(value);
      }, 2000),
      []
    );

    useEffect(
      searched_value_ref !== ""
        ? () => {
          updateSearch(searched_value_ref);
        }
        : () => setSearchedValue(searched_value_ref),
      [searched_value_ref]
    );

    useEffect(() => {
      setPlaylistItems(currentPlaylist?.songs || []);
    }, [currentPlaylist]);

    const playlist_items = useMemo(() => {
      let items = playlist_items_ref.filter((item) =>
        searched_value
          ? item.name.toLowerCase().includes(searched_value.toLowerCase())
          : true,
      );

      if (!sortField?.name) return items;

      const sorted = [...items].sort((a, b) => {
        let aValue;
        let bValue;

        switch (sortField.name) {
          case "name":
            aValue = a.name || "";
            bValue = b.name || "";
            return aValue.localeCompare(bValue);

          case "duration":
            aValue = Number(a.clipsecs || 0);
            bValue = Number(b.clipsecs || 0);
            return aValue - bValue;

          case "temp":
            aValue = Number(a.tempo || 0);
            bValue = Number(b.tempo || 0);
            return aValue - bValue;

          case "genre":
            aValue = a.genre_name || "";
            bValue = b.genre_name || "";
            return aValue.localeCompare(bValue);

          case "player":
            aValue = a.player_name || "";
            bValue = b.player_name || "";
            return aValue.localeCompare(bValue);

          case "added":
            aValue = Number(a.ctimestamp || 0);
            bValue = Number(b.ctimestamp || 0);
            return aValue - bValue;

          default:
            return 0;
        }
      });

      return sortField.direction === "up" ? sorted : sorted.reverse();
    }, [playlist_items_ref, searched_value, sortField]);

    const toggleSelectedS = ({ }, e) => {
      const songTitle = e.target;
      if (songTitle.dataset.playing) {
        return
      }
      document.getSelection().removeAllRanges();


      let id = Number(
        songTitle.dataset.songId ||
        songTitle.parentNode.dataset.songId ||
        songTitle.parentNode.parentNode.dataset.songId
      );
      let i = 0;
      let selection_arr = [];
      let reverse;

      if (e.nativeEvent.shiftKey) {
        e.preventDefault();

        for (let song of Object.values(currentPlaylist.songs)) {
          if (selected_song[0] === song.id) {
            i = 1;
            continue;
          }
          if (i === 1) {
            if (song.id !== id) {
              selection_arr.push(song.id);
            } else {
              selection_arr.push(song.id);
              break;
            }
          }
        }
        if (selection_arr.indexOf(id) === -1) {
          reverse = Object.values(currentPlaylist.songs).reverse();
          console.log(reverse[0]);
          selection_arr = [];
          i = 0;
          for (let track of reverse) {
            if (selected_song[0] === track.id) {
              i = 1;
              continue;
            }
            if (i === 1) {
              if (track.id !== id) {
                console.log(track.id);
                selection_arr.push(track.id);
              } else {
                selection_arr.push(track.id);
                break;
              }
            }
          }
        }
        selection_arr.map((id) => {
          dispatch(
            toggleSelectedSong({
              id_song: id,
              onlyOne: !(
                e.ctrlKey ||
                e.metaKey ||
                e.shiftKey ||
                window.outerWidth <= MEDIA_BREAKPOINT_LG
              ),
            })
          );
        });
        updateCurrentMark();
      }
      if (songTitle && !e.nativeEvent.shiftKey) {
        const songId = Number(
          songTitle.dataset.songId ||
          songTitle.parentNode.dataset.songId ||
          songTitle.parentNode.parentNode.dataset.songId
        );
        if (!isNaN(songId)) {
          dispatch(
            toggleSelectedSong({
              id_song: songId,
              onlyOne: !(
                e.ctrlKey ||
                e.metaKey ||
                e.shiftKey ||
                window.outerWidth <= MEDIA_BREAKPOINT_LG
              ),
            })
          );
          updateCurrentMark();
        }
      }
    };
    const sort = (name) => {
      setSort({
        direction: sortField?.direction === "up" ? "down" : "up",
        name,
      });
    };

    const getItems = useCallback(() => {
      // console.log("playlist_items:", playlist_items.length);

      // return playlist_items.sort((a, b) => Number(a.turn) - Number(b.turn)).map((song, index) => ({
      return playlist_items.map((song, index) => ({
        //return (
        id: song.id,
        name: song.name,
        element: (
          <Song
            key={song.id}
            id={song.id}
            name={song.name}
            turn={song.turn}
            cliptime={song.cliptime}
            selected={selected_song}
            tempo={song.tempo}
            songauthor_name={song.songauthor_name}
            hide_song_author_name={true}
            player_name={song.player_name}
            album_name={song.album_name}
            genre_name={song.genre_name}
            year={song.cdate}
            variant={index % 2 == 0 ? "gray" : ""}
            filename={song.filename}
            play={hPlay}
            pause={hPause}
            stop={hStop}
            rewind={hRewind}
          />
        ),
      }));
    }, [playlist_items]);

    const sameArrays = useMemo(() => {
      const currentIds = currentPlaylist?.songs?.map((el) => el.id) || [];
      const refIds = playlist_items_ref.map((el) => el.id);
      // Сравниваем длину
      if (currentIds.length !== refIds.length) return false;
      // Сравниваем каждый элемент (порядок важен!)
      return currentIds.every((id, index) => id === refIds[index]);
    }, [currentPlaylist?.songs, playlist_items_ref]);

    const savePlaylistPosition = () => {
      dispatch(
        updateMusicPositions({
          playlist_id: currentPlaylist.id,
          turn: playlist_items_ref.map((song) => {
            return song.id;
          }),
        })
      );
    };
    return (
      <>
        {selectedPlaylists?.length === 1 && (
          <>
            <div style={{ marginTop: -62 }}>
              <ElementsGroup position="right">
                <Button
                  type="string"
                  disabled={sameArrays}
                  onClick={savePlaylistPosition}
                >
                  <Save /> Сохранить порядок
                </Button>
                <Button
                  type="string"
                  disabled={selected_song.length > 0 ? false : true}
                  onClick={() =>
                    openModal({
                      type: "confirm",
                      size: "sm",
                      data: {
                        title:
                          "Вы точно хотите удалить выделенные треки из этого плейлиста?",
                        buttons: {
                          cancel: {
                            title: "Вернуться",
                            onClick: () => {
                              closeModal("confirm");
                            },
                          },
                          confirm: {
                            title: "Удалить",
                            onClick: () => {
                              deleteSongs();
                              closeModal("confirm");
                            },
                          },
                        },
                      },
                    })
                  }
                >
                  <Trash /> Удалить из плейлиста{" "}
                  {selected_song.length > 0 ? `(${selected_song.length})` : ""}
                </Button>
                <Button
                  type="string"
                  onClick={selectAllS}
                  disabled={
                    currentPlaylist &&
                      currentPlaylist?.songs &&
                      Object.keys(currentPlaylist.songs).length > 0
                      ? false
                      : true
                  }
                >
                  <Ok size={`xs`} /> Выделить все строки{" "}
                  {currentPlaylist &&
                    currentPlaylist?.songs &&
                    Object.keys(currentPlaylist.songs).length
                    ? `(${Object.keys(currentPlaylist.songs).length})`
                    : ""}
                </Button>
              </ElementsGroup>
            </div>
            <div className="Songs">
              <header className="Songs__control">
                <div className="Songs__grid">
                  <div
                    className={cl("id", { "Songs__grid--active": sortField?.name === 'id' })}
                  >
                    <button
                      className="spp-btn spp-btn_string"
                      onClick={() => sort("name")}
                    >
                      <SvgArrowUpDown className="spp-svg" />
                      <span>ID</span>
                    </button>
                  </div>
                  <div
                    className={cl("composition", { "Songs__grid--active": sortField?.name === 'name' })}
                  >

                    <button
                      className="spp-btn spp-btn_string"
                      onClick={() => sort("name")}
                    >
                      <SvgArrowUpDown className="spp-svg" />
                      ПРОИЗВЕДЕНИЕ
                    </button>
                  </div>
                  <div
                    className={cl("composition", { "Songs__grid--active": sortField?.name === 'duration' })}
                    style={{ marginLeft: 36 }}>
                    <button
                      className="spp-btn spp-btn_string"
                      onClick={() => sort("duration")}
                    >
                      <SvgArrowUpDown className="spp-svg" />
                      <span>ДЛИТ.</span>
                    </button>
                  </div>
                  <div
                    className={cl("temp", { "Songs__grid--active": sortField?.name === 'temp' })}
                    style={{ width: '50%', textAlign: 'start' }}
                  >
                    <button
                      className="spp-btn spp-btn_string"
                      onClick={() => sort("temp")}

                    >
                      <SvgArrowUpDown className="spp-svg" />
                      <span>ТЕМП</span>
                    </button>
                  </div>
                  <div
                    className={cl("chill_out", { "Songs__grid--active": sortField?.name === 'genre' })}
                  >
                    <button
                      className="spp-btn spp-btn_string"
                      onClick={() => sort("genre")}
                    >
                      <SvgArrowUpDown className="spp-svg" />
                      <span>ЖАНР</span>
                    </button>
                  </div>

                  <div className="performer" hidden>
                    <button
                      className="spp-btn spp-btn_string"
                      onClick={() => sort("player")}
                    >
                      <SvgArrowUpDown className="spp-svg" />
                      <span>ИСПОЛНИТЕЛЬ</span>
                    </button>
                  </div>
                  {/* <div className="album">
                            <button
                                className="spp-btn spp-btn_string"
                                onClick={ () => sort("album") }
                            >
                                <SvgArrowUpDown className="spp-svg" />
                                <span>АЛЬБОМ</span>
                            </button>
                        </div> */}
                  <div
                    className={cl("added", { "Songs__grid--active": sortField?.name === 'added' })}

                  >
                    <button
                      className="spp-btn spp-btn_string"
                      onClick={() => sort("added")}
                    >
                      <SvgArrowUpDown className="spp-svg" />
                      <span>ДОБАВЛЕНО</span>
                    </button>
                  </div>
                </div>
              </header>
              <div onClick={toggleSelected}>
                {!loading && <List
                  type="simple"
                  scroll={{
                    on: true,
                    data: {
                      variant: "white",
                      size: "sm",
                    },
                  }}
                  onClick={toggleSelectedS}
                  content={{ items: getItems(), variant: "none", keyPrefix: "UserPlaylist_song_" }}
                  // droppableId={ `ownPlaylistSongs` }
                  droppableId={`0`}
                />}
              </div>
            </div>
          </>
        )}
      </>
    );
  }
);

export default UserPlaylist;
